__turbopack_context__.v({
  "answer": "styles-module-scss-module__mRweVq__answer",
  "arrow": "styles-module-scss-module__mRweVq__arrow",
  "arrowIcon": "styles-module-scss-module__mRweVq__arrowIcon",
  "faqItem": "styles-module-scss-module__mRweVq__faqItem",
  "faqList": "styles-module-scss-module__mRweVq__faqList",
  "open": "styles-module-scss-module__mRweVq__open",
  "question": "styles-module-scss-module__mRweVq__question",
  "questionRow": "styles-module-scss-module__mRweVq__questionRow",
  "root": "styles-module-scss-module__mRweVq__root",
});
